import React from "react";
import Avatar from "@material-ui/core/Avatar";
import AvatarGroup from "@material-ui/lab/AvatarGroup";
import { Tooltip } from "@material-ui/core";
import SystemLabel from "../system/SystemLabel/SystemLabel";

export default function GroupAvatars({ people, target }) {
  return (
    <>
      <Tooltip
        title={
          <span style={{ fontSize: 15 }}>
            <SystemLabel name="ExpoChatGroupTooltip" />
            {target}<br></br><br/>
            {people.map((p) => {
              return (
                <>
                  <span>⭐ {p.name}</span>
                  <br />
                </>
              );
            })}
          </span>
        }
      >
        <AvatarGroup max={3}>
          {people.map((p) => {
            return <Avatar key={p.badgeNo} alt={p.name} src={p.profileImage} />;
          })}
        </AvatarGroup>
      </Tooltip>
    </>
  );
}
